module.exports = __webpack_public_path__ + "static/media/spinner.8e82b695.svg";